export const pageHeaders: { [key: string]: string } = {
    "app-development": "App Development",
    "ui-ux-mockups": "UI/UX Mockups",
    "game-design": "Game Design",
};